import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Wrapper, IconStyled } from 'apps/profile/views/item.styles';

export const ProfileItem = observer(({ deleteHandler, item }) => {
  return (
    <Wrapper>
      <span>{item.username}</span>
      <IconStyled
        onClick={() => deleteHandler(item)}
        key={`${item.username}-delete`}
        name='close'
        size='8px'
      />
    </Wrapper>
  );
});

ProfileItem.propTypes = {
  item: PropTypes.object,
  deleteHandler: PropTypes.func,
};
